import BannerWordRotate from "./components/BannerWordRotate";
import DeviceEvaluationForm from "./components/DeviceEvaluationForm";
import FAQ from "./components/Faq";
import FeatureCards from "./components/FeatureCards.js";
import ProductsPage from "./components/ProductPage";
import SecurityBlock from "./components/SecurityBlock";

const Home2 = () => {
  return (
    <>
      <BannerWordRotate />
      <ProductsPage category="Apple" />

      <DeviceEvaluationForm />

      <FeatureCards />
      <SecurityBlock />
      <FAQ />
    </>
  );
};

export default Home2;
